import React from 'react';
import { makeStyles } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';
import FlagstoneTheme from '../../Config/flagstoneTheme';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Timer from '../Shared/Timer';
import { configureStartTimeByDuration, fromNewDateFormatToYYYYMMDDHHmmss } from '../../Helpers/dateHelper'
import { generateNewId } from '../../Helpers/generalHelper'


export default function WorkstationStatusContent(props) {
    const classes = useStyles();

    let statusColor = ""
    let icon = <React.Fragment></React.Fragment>
    switch (props.status.type) {
        case "warning":
            statusColor = "#F59128";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            break;
        case "error":
            statusColor = "#D84949";
            icon = <ErrorIcon className={classes.errorIcon}></ErrorIcon>;
            break;
        case "running":
            statusColor = "#5CC958";
            icon = <InfoIcon className={classes.infoIcon}></InfoIcon>;
            break;
        default:
    }

    const changeWorkstationStatus = (statusId) => {
        if (statusId !== props.status.id) {
            let tempWorkstations = Object.assign([], props.workstation.workstations)
            tempWorkstations.find(x => x.id === props.workStation.id).status = statusId
            tempWorkstations.find(x => x.id === props.workStation.id).statusDuration = "00:00"
            if (statusId !== 1) {
                let type = ""
                if (statusId === 2 || statusId === 3) {
                    type = "maintenance"
                }
                else {
                    type = props.statusses.find(x => x.id === statusId).type
                }

                var i;
                let messagesArray = []
                for (i = 0; i < tempWorkstations.length; i++) {

                    var y;
                    for(y =0; y < tempWorkstations[i].messages.length; y++){
                        messagesArray.push(tempWorkstations[i].messages[y])
                    }
                }

                tempWorkstations.find(x => x.id === props.workStation.id).messages.push({ id: generateNewId(messagesArray), type: type, time: fromNewDateFormatToYYYYMMDDHHmmss(new Date()), machine: "production line " + props.workStation.id, message: props.statusses.find(x => x.id === statusId).description, read: false })
            }
            props.actions.setWorkstations(tempWorkstations)
        }
    }

    return (
        <React.Fragment>
            <div className={classes.header}>
                <div className={classes.statusContainer}>
                    <div className={classes.label}>
                        Status
                    </div>
                    <div className={classes.status}>
                        <div className={classes.statusIcon} style={{ color: statusColor }}>
                            {icon}
                        </div>
                        <div className={classes.statusText} style={{ color: statusColor }}>
                            {props.status.type}
                        </div>
                    </div>
                </div>
                <div className={classes.duration}>
                    <Timer duration = {props.workStation.duration} {...props} startTime = {configureStartTimeByDuration(props.workStation.duration)} actions={props.actions}></Timer>                    
                </div>
            </div>
            <div className={classes.statusList}>
                <List>
                    {props.statusses.map(x => (<button className={classes.statusButton} onClick={() => changeWorkstationStatus(x.id)} key={x.id}><ListItem style={{ borderRadius: x.id === 1 ? "6px 6px 0  0" : x.id === props.statusses.length ? "0  0 6px 6px" : "" }} className={clsx({ [classes.warningListItem]: x.id === props.status.id && x.type === 'warning', [classes.errorListItem]: x.id === props.status.id && x.type === 'error', [classes.runningListItem]: x.id === props.status.id && x.type === 'running', [classes.notActiveListItem]: x.id !== props.status.id })}>
                        <div className={classes.description}>{x.description}</div>
                        {x.id === props.status.id ? <div className={classes.statusDuration}><Timer duration={props.workStation.statusDuration} {...props} actions={props.actions} startTime = {configureStartTimeByDuration(props.workStation.statusDuration)}></Timer></div> : <div className={classes.arrowContainer}><ArrowForwardIosIcon className={classes.arrowForward}></ArrowForwardIosIcon></div>}
                    </ListItem></button>
                    )
                    )}
                </List>

            </div>
        </React.Fragment>
    )

}

const useStyles = makeStyles(() => ({
    statusContainer: {
        width: "70%",
        display: 'inline-block'
    },
    duration: {
        width: "30%",
        display: 'inline-block',
        textAlign: "right",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#020100',
        paddingTop: "10px"
    },
    statusIcon: {
        float: 'left',
        marginTop: "8px",
        marginRight: "3px"
    },
    errorIcon: {
        width: "27px",
        height: "27px"
    },
    infoIcon: {
        width: "27px",
        height: "27px"
    },
    statusText: {
        float: 'left',
        fontSize: "32px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        textTransform: "capitalize"
    },
    label: {
        fontSize: "15px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: '#8D8D8D'
    },
    runningListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#5CC958',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #5CC958"
    },
    warningListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#F59127',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #F59127"

    },
    errorListItem: {
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'bold',
        color: '#D84949',
        backgroundColor: "white",
        paddingTop: "10px",
        paddingBottom: "10px",
        border: "1px solid #D84949"
    },
    notActiveListItem: {
        backgroundColor: "#4654FB22",
        marginTop: "2px",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'Medium',
        color: FlagstoneTheme.palette.primary.main,
        paddingTop: "10px",
        paddingBottom: "10px",
        cursor: "pointer"

    },
    header: {
        marginBottom: "5px"
    },
    statusDuration: {
        fontSize: "13px !important",
        fontFamily: "Lato, sans-serif",
        fontWeight: "normal",
        color: '#8D8D8D',
        float: "right",
        width: "calc(100% - 150px)",
        textAlign: "right"
    },
    description: {
        width: "150px"
    },
    arrowForward: {
        color: FlagstoneTheme.palette.primary.main,
        width: "15px",
        height: "15px",
        float: "right",
    },
    arrowContainer: {
        float: "left",
        width: "calc(100% - 150px)",
        textAlign: "right"
    },
    statusButton: {
        width: "100%",
        border: "none",
        outline: "none",
        backgroundColor: "white"
    }
}));